// extracted by css-extract-rspack-plugin
export default {"environment":"k9FnQmCB1rgdjB3j","color":"pnCwSRNJE7sZ9R8Z","display":"ZUi9FIae_Bw7bkD3"};